import React, { useState } from "react";
import { ICustomerEmployment } from "../../Interfaces/Customer/ICustomerEmployment";
import { DialogProps } from "./DialogProps";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import EmploymentInfo from "../Views/OrderEditor/EmploymentInfo";
import {hasValue} from "@amsanalytics/react-shared-library";
import { useSelector } from "react-redux";
import { AppState } from '../../store/rootReducer';
import { Constants } from "../../utils/constants";

export interface EmploymentDialogProps extends DialogProps<ICustomerEmployment> {
  employment?: ICustomerEmployment;
  isReadOnly: boolean;
}

export default function EmploymentDialog(props: EmploymentDialogProps) {
  const lookups = useSelector((state: AppState) => state.applications.lookups);
  const [employment, setEmployment] = useState<Partial<ICustomerEmployment>>(
    props.employment
    ?? {
      streetAddress: '',
      city: '',
      zipCode: '',
      primaryEmployment: false,
      isCurrent: false,
      endDate: undefined,
      customerEmploymentStatusId: Constants.customerEmploymentStatuses.notVerifiedId
    });
  const [errors, setErrors] = useState<Error[]>([]);
  const updateEmployment = (customerEmployment: ICustomerEmployment): void => {
    setEmployment({
      ...customerEmployment,
      isCurrent: customerEmployment.primaryEmployment ? true : customerEmployment.isCurrent
    });
    if (errors.length > 0) validateEmployment(employment);
  };
  const validateEmployment = (customerEmployment: Partial<ICustomerEmployment>): boolean => {
    const errors: Error[] = [];
    if (!hasValue(customerEmployment.companyName)) {
      const error = new Error('Company Name is required');
      error.name = 'CompanyName';
      errors.push(error);
    }
    setErrors(errors);
    return errors.length === 0;
  };
  return (
    <>
      <DialogTitle style={{ cursor: "move" }}>
        Add Employment
      </DialogTitle>
      <DialogContent>
        <EmploymentInfo
          errors={errors}
          onUpdateEmployment={updateEmployment}
          employmentInfo={employment as ICustomerEmployment}
          customerEmploymentStatuses={lookups.customerEmploymentStatuses}
          customerEmploymentVerificationOptions={lookups.customerEmploymentVerificationOptions}
          newEmploymentDialog={true}
          isReadOnly={props.isReadOnly}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeDialog} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (validateEmployment(employment)) {
              props.accept && props.accept({ ...employment } as ICustomerEmployment);
            }
          }}
          color="primary"
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}
